import { render, staticRenderFns } from "./StudyRank.vue?vue&type=template&id=1835ccf8&scoped=true&"
import script from "./StudyRank.vue?vue&type=script&lang=js&"
export * from "./StudyRank.vue?vue&type=script&lang=js&"
import style0 from "./StudyRank.vue?vue&type=style&index=0&id=1835ccf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1835ccf8",
  null
  
)

component.options.__file = "StudyRank.vue"
export default component.exports